import Image from 'next/image'
import { FC } from 'react'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { AppButton } from '@/components/shared/button'

type Props = {
  onNavigateToList: () => void
}

const RequestBookingSuccess: FC<Props> = ({ onNavigateToList }) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  return (
    <>
      <div className="mt-[-210px] flex flex-grow flex-col items-center justify-center sm:mt-0">
        <Image
          src="/images/passes/Parking.png"
          width={isMobileScreen ? 90 : 180}
          height={isMobileScreen ? 90 : 180}
          alt="parking-image"
          className="flex justify-center"
        />
        <p className="mt-22 text-center text-grey-70 text-20 sm:text-16">
          Пропуск создан. Оплатить его можно в разделе «Пропуска»
        </p>
      </div>

      <AppButton
        fluid
        size={isMobileScreen ? 'small' : 'large'}
        onClick={onNavigateToList}
        className="mb-20 mt-auto sm:mb-10"
        variant="secondary"
      >
        К пропускам
      </AppButton>
    </>
  )
}

export { RequestBookingSuccess }
